import EditablePropsType from '../../../types/composer';

export const wordPressSchema = {
  type: EditablePropsType.Boolean,
  label: 'WordPress Block',
  name: 'isWordPressBlock',
};

export default wordPressSchema;
